export default __webpack_public_path__ + "static/media/marketing-image-section4.92d0ada4.png";